// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#\\@vmos-vmos-flyout-app__bzI22 button{cursor:pointer}.\\@vmos-vmos-flyout-flyout-group__3JFO_{border-bottom:1px solid #e5e5e5;padding:var(--wb-spacing-xs) 0}.\\@vmos-vmos-flyout-flyout-group__3JFO_:first-child{padding-top:0}.\\@vmos-vmos-flyout-flyout-group__3JFO_:last-child{border-bottom:none;padding-bottom:0}@media(min-width:1280px){.\\@vmos-vmos-flyout-flyout-group__3JFO_:last-child{border-bottom:1px solid #e5e5e5;padding:var(--wb-spacing-xs) 0;margin-bottom:var(--wb-spacing-s)}}", ""]);
// Exports
exports.locals = {
	"app": "@vmos-vmos-flyout-app__bzI22",
	"flyoutGroup": "@vmos-vmos-flyout-flyout-group__3JFO_"
};
module.exports = exports;
